import { useState } from "react";
import { createAppointment } from "../../api/appointmentService";

export const useCreateAppointment = (successCallback) => {
  const [creating, setCreating] = useState(false);
  const create = async (data) => {
    setCreating(true);
    try {
      const newRecord = await createAppointment(data);
      setCreating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setCreating(false);
      console.error("Failed to create appointment:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { create, creating };
};